export default [
  {
    title: 'Sobre a Simplic',
    text: `A Simplic é a primeira empresa a oferecer o serviço de crédito pessoal online no Brasil. Através de tecnologia própria e um avançado sistema de análise de dados, todo processo do cadastro até a avaliação de crédito pode ser feito em poucos minutos. Os melhores créditos pessoais estão no Simplic!`,
  },
  {
    title: 'O que é empréstimo sem garantia?',
    text: `
      O Empréstimo Simplic é uma maneira descomplicada para se obter crédito de forma fácil, segura e rápida - você pode ter o dinheiro creditado em sua conta em poucas horas!
      <br />
      O Empréstimo Simplic não requer nenhuma garantia e é destinado para qualquer pessoa maior de 18 anos, com CPF ativo e conta bancária no Bradesco, Caixa, Itaú ou Santander.
      <br />
      Para solicitar, basta escolher o valor e preencher as informações de cadastro! É possível realizar um pedido de empréstimo entre R$500 e R$3.500 que poderá ser dividido em 3, 6, 9 ou 12 parcelas mensais.
      <br />
      Ressaltamos que a Simplic não cobra nenhuma espécie de depósito antecipado e, a qualquer momento, você pode solicitar a antecipação de uma ou mais parcelas com desconto!
    `,
  },
  {
    title: 'Quais são as etapas de solicitação da oferta pré-aprovada?',
    text: `
      É super simples!
      <br />
      <ul>
        <li>Após clicar em “Solicitar oferta”;</li>
        <li>Clique em “continuar”.</li>
        <li>Depois disso, você será direcionado (a) para o site da Simplic para dar continuidade.</li>
      </ul>
      <br />
      É só preencher todos os dados e seguir o que se pede. Após concluir essa primeira etapa, você precisará baixar o aplicativo da parceira para dar continuidade.
    `,
  },
  {
    title: 'O empréstimo Simplic é confiável?',
    text: `
      A Simplic é a primeira correspondente bancária que oferece a contratação de crédito pessoal online, sem precisar sair de casa, sem filas, papéis ou constrangimentos – já são milhares de clientes satisfeitos desde 2014!
      <br />
      Trabalhamos de acordo com todos os requisitos do Banco Central do Brasil e utilizamos tecnologias avançadas para garantir a maior segurança para você.
      <br />
      Vale lembrar que nenhum valor é cobrado antecipadamente. As taxas e encargos do serviço serão incluídos no valor das parcelas em caso de aprovação da proposta. Todas as propostas de crédito pessoal online são tratadas com muita transparência e privacidade.
    `,
  },
  {
    title:
      'Posso alterar a data de vencimento da parcela do meu empréstimo pessoal?',
    text: `Não, conforme consta em contrato, não é possível alterar a data de vencimento da parcela do seu empréstimo. O débito da parcela é feito em sua conta de forma automática na data estipulada em seu contrato.`,
  },
  {
    title: 'Qual a taxa de juros da Simplic?',
    text: `A taxa de juros pode variar de 15,80% a 17,90% ao mês e será calculada sempre proporcionalmente aos dias decorridos.`,
  },
  {
    title: 'Quais são os requisitos para pedir um empréstimo?',
    text: `Você precisa ter um CPF válido, ter mais de 18 anos e uma conta bancária no Bradesco, Caixa, Itaú ou Santander.`,
  },
  {
    title: 'Por que meu banco ainda não é atendido pelo Simplic?',
    text: `Por enquanto, a Simplic trabalha apenas com o Bradesco, Itaú, Santander e Caixa.`,
  },
  {
    title: 'Por que preciso informar minha conta bancária?',
    text: `
      Os dados da sua conta bancária pessoal são essenciais para receber o valor solicitado de forma automática (transferência bancária). Sem o fornecimento, não há como a Simplic fazer o crédito para você. Para sua segurança, a Simplic só irá transferir dinheiro para contas vinculadas ao seu CPF. Não importa se o valor do empréstimo será repassado posteriormente para familiares, amigos ou fornecedores. O empréstimo é pessoal e só será depositado na sua própria conta bancária. Além disso, sua conta bancária será debitada automaticamente nos dias de vencimento das parcelas. Simples para receber, simples para pagar. Empréstimo rápido, seguro e sem burocracia.
    `,
  },
  {
    title: 'Faz empréstimo para negativado?',
    text: `
      Sim! É possível solicitar um empréstimo mesmo com seu nome negativado nos órgãos de proteção ao crédito.
    `,
  },
  {
    title: 'Quanto tempo demora para saber se fui aprovado?',
    text: `
      Após a assinatura digital da proposta de crédito, alguns clientes são aprovados minutos após o pedido do empréstimo pessoal. Em alguns casos, precisaremos de verificações adicionais. Isso pode incluir a validação da sua conta bancária, do seu telefone, do seu extrato bancário através da Simplic Express ou enviando documentos adicionais. Após o envio, informaremos em poucas horas por e-mail o resultado do pedido de empréstimo pessoal. Sempre que ficar com dúvidas sobre sua aprovação, entre em contato com nossa central de atendimento.
    `,
  },
  {
    title: 'Como faço para pagar meu empréstimo?',
    text: `
      Pagar seu empréstimo pessoal online é muito simples. No dia do vencimento das suas parcelas, sua conta bancária cadastrada será debitada automaticamente com o valor acordado e autorizado por você no momento do contrato. Se não houver saldo suficiente em sua conta bancária, você poderá entrar no cheque especial e passará a dever encargos também ao seu banco. Por isso, organize-se para ter sempre saldo na conta indicada por você. Existe também a opção de adiantar o pagamento para conseguir um desconto na parcela, uma ótima opção para quando sobrar aquele dinheirinho.
    `,
  },
  {
    title: 'Em quanto tempo vou receber o dinheiro na minha conta bancária?',
    text: `
      O depósito do dinheiro será feito em sua conta até o final do dia caso o e-mail de aprovação do empréstimo tenha sido recebido até às 13:00h de um dia útil. Caso tenha recebido o e-mail após às 13:00h, o depósito do dinheiro ocorrerá até às 15:00h do próximo dia útil.
    `,
  },
  {
    title:
      'Preenchi a proposta, mas o site me sugeriu um novo valor para empréstimo. Por quê?',
    text: `
      Após o preenchimento de seu pedido de empréstimo pessoal Simplic, o site pode oferecer uma contraproposta adequada às informações fornecidas no seu perfil. Caso você tenha aceitado o novo valor e parcelamento, basta seguir com o seu pedido.
    `,
  },
  {
    title: 'Estou com dificuldades para acessar o site, o que devo fazer?',
    text: `
      O site da Simplic, foi projetado para ser visualizado pela maioria dos dispositivos sem qualquer tipo de problema. Porém, falhas em sua rede de internet ou problemas de compatibilidade podem ter dificultado seu acesso. Recomendamos que acesse o site de um computador residencial ou de uma lan house e utilize os navegadores Google Chrome ou Mozilla Firefox, que são 100% compatíveis com nossa plataforma.
    `,
  },
  {
    title: 'Para quando é a primeira parcela?',
    text: `
      Depende da data da solicitação do empréstimo e da data de vencimento que será disponibilizada para você. A data de vencimento é calculada automaticamente de acordo com a data de recebimento do salário.
    `,
  },
  {
    title: 'Esqueci minha senha. Como faço para recuperá-la?',
    text: `
      Para redefinir sua senha, basta entrar na área de login  e escolher a opção “Esqueceu sua senha? ou redefinir a senha através do link:
      <br />
      https://www.simplic.com.br/redefinir_senha
      <br />
      Insira seu endereço de e-mail e clique em “Redefinir Senha” que você receberá um e-mail contendo um link para cadastro de uma nova senha de acesso. 
    `,
  },
]
